import { BaseState } from 'store/ducks/types';
import { ReportType, StatementList } from '../statements/types';

export enum ExportsTypes {
  ExportsRequest = '@exports/EXPORTS_REQUEST',
  ExportsSuccess = '@exports/EXPORTS_SUCCESS',
  ExportsFailure = '@exports/EXPORTS_FAILURE',
  ClearExportsList = '@exports/CLEAR_LIST',
}

export interface ExportsRequestPayload {
  periodStart: string;
  periodEnd?: string;
  reportType?: ReportType;
  document?: string;
}

export interface ExportsResponse {
  statements: StatementList;
}

export interface StatementPreparedToExport {
  id: number;
  date: string;
  hour: string;
  description: string;
  status: string;
  transferType: string;
  transferId: string;
  originAccountId: string;
  originClientId: string;
  originClientName: string;
  originDocument: string;
  originBank: string;
  originAgency: string;
  originAccount: string;
  destinationAccountId: string;
  destinationClientId: string;
  destinationClientName: string;
  destinationDocument: string;
  destinationBank: string;
  destinationAgency: string;
  destinationAccount: string;
  balanceFormatted: string;
  amountFormatted: string;
}

export type StatementsPreparedToExport = StatementPreparedToExport[];

export interface ExportsState extends BaseState {
  readonly statements: StatementList;
}
